import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { faArrowRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState, useRef } from "react";
import "../DesktopView/ExecutionAndDocumentationDesktopView.css";
import axios from "axios";
import { useLocation } from "react-router-dom";
import CryptoJS from "crypto-js";
import JSZip from "jszip";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import search from "../../../images/Search.png";

function ExecutionAndDocumentationDesktopStep4({
  getDocument,
  documentResponse,
}) {
  const baseAPI = process.env.REACT_APP_API_URL;
  const baseImageURL = process.env.REACT_APP_IMAGE_URL;
  const location = useLocation();
  const fileInputRef = useRef(null);
  const [isUploaded, setIsUploaded] = useState(false);
  const [uploadedDocumentTypeId, setUploadedDocumentTypeId] = useState(null);

  const [individualDocResponse, setIndividualDocResponse] = useState(null);
  const [individualDocResponse2, setIndividualDocResponse2] = useState(null);
  const [individualDocResponse3, setIndividualDocResponse3] = useState(null);

  const [dateValue1, setDateValue1] = useState("");
  const [dateValue2, setDateValue2] = useState("");
  const [dateValue3, setDateValue3] = useState("");
  let updateData = documentResponse;

  useEffect(() => {
    getIndividualDoc(14);
    getIndividualDoc(18);
    getIndividualDoc(12);

    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (updateData) {
      const individualDocResponse = updateData.filter(
        (doc) => doc.document_type_id === 14
      );
      const individualDocResponse2 = updateData.filter(
        (doc) => doc.document_type_id === 18
      );
      const individualDocResponse3 = updateData.filter(
        (doc) => doc.document_type_id === 12
      );

      setIndividualDocResponse(individualDocResponse);
      setIndividualDocResponse2(individualDocResponse2);
      setIndividualDocResponse3(individualDocResponse3);
    }
  }, [updateData]);

  const searchParams = new URLSearchParams(location.search);
  const encryptedRelocationID = searchParams.get("ID");
  const Relocation_ID = decryptRelocationID(encryptedRelocationID);

  const [firstItem, setFirstItem] = useState({
    relocation_id: Relocation_ID,
    doc_ID: "",
    documentTypeId: "",
    manual_createdDate: "",
    validity: "",
    document: "",
    doc_name: "",
    is_Active: "",
    is_submit: "",
    user_type: 3,
  });

  function decryptRelocationID(ciphertext) {
    try {
      const bytes = CryptoJS.AES.decrypt(
        decodeURIComponent(ciphertext),
        "dbbworldwidepvtltd"
      );
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error("Error decrypting Relocation_ID:", error);

      return null;
    }
  }

  function getIndividualDoc(documentTypeId) {
    const storedToken = JSON.parse(localStorage.getItem("accessToken"));

    if (storedToken) {
      axios
        .get(
          `${baseAPI}customerget/GetCustomerDocumentsDetail?relocation_id=` +
            Relocation_ID +
            `&option=1&is_submit=0&documentTypeId=0`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          let data = response.data.data;

          // Divide the array based on documentTypeId
          const individualDocResponse = data.filter(
            (doc) => doc.document_type_id === 14
          );
          const individualDocResponse2 = data.filter(
            (doc) => doc.document_type_id === 18
          );
          const individualDocResponse3 = data.filter(
            (doc) => doc.document_type_id === 12
          );

          // Set the responses
          setIndividualDocResponse(individualDocResponse);
          setIndividualDocResponse2(individualDocResponse2);
          setIndividualDocResponse3(individualDocResponse3);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }

  const uploadVaccinationBook = async (documentTypeId) => {
    if (!firstItem.doc_name) {
      alert("Please select a file before uploading.");
      return; // Exit the function early if no file is selected
    }

    const formData = new FormData();

    if (documentTypeId === 14) {
      firstItem.manual_createdDate = dateValue1;
    }

    if (documentTypeId === 18) {
      firstItem.manual_createdDate = dateValue2;
    }

    if (documentTypeId === 12) {
      firstItem.manual_createdDate = dateValue3;
    }

    // Append form fields and the file to FormData
    formData.append("relocation_id", Relocation_ID);
    formData.append("documentTypeId", documentTypeId);
    formData.append("validity", firstItem.validity);
    formData.append("manual_createdDate", firstItem.manual_createdDate);
    formData.append("doc_name", firstItem.doc_name);
    formData.append("user_type", 3);

    try {
      const storedToken = JSON.parse(localStorage.getItem("accessToken"));
      const response = await axios.post(
        `${baseAPI}customerpost/UpdateCustomerDocumentsDetail`,
        formData, // Send request body
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.status === 200) {
        setIsUploaded(true); // Set upload status to true on success
      }
      setUploadedDocumentTypeId(documentTypeId);
      getIndividualDoc(documentTypeId);

      setFirstItem({
        relocation_id: Relocation_ID,
        doc_ID: "",
        documentTypeId: "",
        manual_createdDate: "",
        validity: "",
        document: "",
        doc_name: "",
        is_Active: "",
        is_submit: "",
        user_type: 3,
      });

      setDateValue1("");
      setDateValue2("");
      setDateValue3("");

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  function isValidFileType(file) {
    const allowedTypes = [
      "image/jpeg",
      "image/png",
      "application/pdf",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // DOCX
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // XLSX
      "application/vnd.ms-excel", // XLS
      "video/mp4",
      "video/x-msvideo", // AVI
      "video/x-matroska", // MKV
      "video/quicktime", // MOV
      "application/zip", // ZIP
      "application/x-zip-compressed", // Alternate ZIP MIME type
    ];
    return file && allowedTypes.includes(file.type);
  }

  function validateZipFile(file, name, e) {
    const reader = new FileReader();
    reader.onload = function (event) {
      const zipData = event.target.result;

      try {
        const jszip = new JSZip();
        jszip.loadAsync(zipData).then((zip) => {
          const allowedExtensions = ["jpg", "png", "pdf", "docx", "xlsx"];
          let isValid = true;

          zip.forEach((relativePath, zipEntry) => {
            const extension = relativePath.split(".").pop().toLowerCase();
            if (!allowedExtensions.includes(extension)) {
              isValid = false;
            }
          });

          if (isValid) {
            getUpdatedImage(file, name);
          } else {
            alert("ZIP file contains unsupported file types.");
            e.target.value = null;
          }
        });
      } catch (error) {
        alert("Error reading ZIP file.");
        e.target.value = null;
      }
    };
    reader.readAsArrayBuffer(file);
  }

  function getUpdatedImage(file, name) {
    if (file) {
      setFirstItem({
        ...firstItem,
        [name]: file, // Store the file object directly
      });
    }
  }

  function handleChangeDoc(e) {
    const { name, value, files } = e.target;

    if (name === "doc_name") {
      const file = files[0];
      if (file.size > 50 * 1024 * 1024) {
        alert("File size exceeds 50 MB limit.");
        e.target.value = null;
        return;
      }

      if (isValidFileType(file)) {
        if (
          file.type === "application/zip" ||
          file.type === "application/x-zip-compressed"
        ) {
          validateZipFile(file, name, e);
        } else {
          getUpdatedImage(file, name);
        }
      } else {
        alert("Unsupported file type. Please upload a valid file.");
        // Reset the file input field
        e.target.value = null;
        return;
      }
    } else {
      setFirstItem({
        ...firstItem,
        [name]: value,
      });
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "dateValue1") {
      setDateValue1(value);
    } else if (name === "dateValue2") {
      setDateValue2(value);
    } else if (name === "dateValue3") {
      setDateValue3(value);
    }
  };

  const formatDate = (dateString) => {
    const options = {
      day: "numeric",
      month: "short",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };

    const formattedDate = new Date(dateString).toLocaleString("en-US", options);
    return formattedDate;
  };

  async function deleteDoc(doc_ID) {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this document?"
    );

    if (isConfirmed) {
      const storedToken = JSON.parse(localStorage.getItem("accessToken"));
      // Make a POST request to your API endpoint
      const response = await axios.post(
        `${baseAPI}customerpost/UpdateCustomerDocsDelete`,
        {
          doc_ID: doc_ID, // Request body
        },
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );

      setIndividualDocResponse((prevDocs) =>
        prevDocs.filter((doc) => doc.doc_ID !== doc_ID)
      );

      setIndividualDocResponse2((prevDocs) =>
        prevDocs.filter((doc) => doc.doc_ID !== doc_ID)
      );
      setIndividualDocResponse3((prevDocs) =>
        prevDocs.filter((doc) => doc.doc_ID !== doc_ID)
      );
    }
  }

  async function submitDocument(doc_ID) {
    try {
      const storedToken = JSON.parse(localStorage.getItem("accessToken"));
      // Make a POST request to your API endpoint
      const response = await axios.post(
        `${baseAPI}customerpost/UpdateCustomerDocsSubmit`,
        { doc_ID: doc_ID },
        {
          // Send request body
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
      getDocument();
    } catch (error) {
      // Handle errors (e.g., show an error message)
      console.error("Error posting data:", error);
    }
  }

  return (
    <>
      <div
        className="p-4 mt-4"
        style={{ backgroundColor: "rgb(250, 250, 250)", borderRadius: "8px" }}
      >
        <h4 style={{ fontSize: "20px" }}>1. Passport Verification.</h4>
        <h6 className="px-4" style={{ fontSize: "16px", color: "#A0A0A0" }}>
          We need to verify the passport details of the pet parent to ensure no
          discrepancies occur on the day of travel.{" "}
          <span style={{ color: "#0096EB" }}>More Info</span>
        </h6>
        <form className="relocation-details-main-form mt-0 px-2 execution-step-1-form">
          <div className="form-row mt-0 row align-items-center">
            <div className="col-4" style={{ marginTop: "15px" }}>
              <label
                style={{ color: "#3D3D3D", marginRight: "10px" }}
                htmlFor=""
              >
                Date of passport submission.
              </label>
              <div className="d-flex align-items-baseline">
                <input
                  id="vaccinationDate"
                  style={{
                    border: "2px solid #6a6a6a",
                    width: "100%",
                    borderTopLeftRadius: "8px",
                    borderBottomLeftRadius: "8px",
                    borderTopRightRadius: "0px",
                    borderBottomRightRadius: "0px",
                  }}
                  type="date"
                  className="form-control m-0"
                  placeholder="Enter"
                  name="dateValue1"
                  value={dateValue1}
                  onChange={handleChange}
                />
                <button
                  style={{
                    border: "2px solid #5B489D",
                    marginLeft: "6px",
                    backgroundColor: "#F8F9FACC",
                    color: "#6a6a6a",
                    with: "114px",
                    padding: "6px 16px 6px 16px",
                    borderTopRightRadius: "8px",
                    borderBottomRightRadius: "8px",
                  }}
                  type="submit"
                  className="form-button execution-update-btn"
                >
                  Update
                </button>
              </div>
            </div>

            <div className="col-4" style={{ marginTop: "15px" }}>
              <label
                style={{ color: "#3D3D3D", marginRight: "10px" }}
                htmlFor=""
              >
                Passport Validity
              </label>
              <div className="d-flex align-items-baseline">
                <input
                  id="vaccinationDate"
                  style={{
                    border: "2px solid #6a6a6a",
                    width: "100%",
                    borderTopLeftRadius: "8px",
                    borderBottomLeftRadius: "8px",
                    borderTopRightRadius: "0px",
                    borderBottomRightRadius: "0px",
                  }}
                  type="date"
                  className="form-control m-0"
                  placeholder="Enter"
                  name="validity"
                  value={firstItem.validity}
                  onChange={handleChangeDoc}
                />
                <button
                  style={{
                    border: "2px solid #5B489D",
                    marginLeft: "6px",
                    backgroundColor: "#F8F9FACC",
                    color: "#6a6a6a",
                    with: "114px",
                    padding: "6px 16px 6px 16px",
                    borderTopRightRadius: "8px",
                    borderBottomRightRadius: "8px",
                  }}
                  type="submit"
                  className="form-button execution-update-btn"
                >
                  Update
                </button>
              </div>
            </div>

            <div className="col-4" style={{ marginTop: "15px" }}>
              <label
                style={{ color: "#3D3D3D", marginRight: "10px" }}
                htmlFor=""
              >
                Upload Document
              </label>
              <div className="d-flex align-items-baseline">
                <input
                  id="vaccinationDate"
                  style={{
                    border: "2px solid #6a6a6a",
                    width: "100%",
                    borderTopLeftRadius: "8px",
                    borderBottomLeftRadius: "8px",
                    borderTopRightRadius: "0px",
                    borderBottomRightRadius: "0px",
                  }}
                  type="file"
                  className="form-control m-0"
                  placeholder="Enter"
                  name="doc_name"
                  onChange={handleChangeDoc}
                  ref={fileInputRef}
                  required
                />
                <button
                  style={{
                    border: "2px solid #5B489D",
                    marginLeft: "6px",
                    backgroundColor: "#F8F9FACC",
                    color: "#6a6a6a",
                    with: "114px",
                    padding: "6px 16px 6px 16px",
                    borderTopRightRadius: "8px",
                    borderBottomRightRadius: "8px",
                  }}
                  className="form-button execution-update-btn"
                  onClick={(e) => {
                    e.preventDefault(); // Explicitly prevent default form submission
                    uploadVaccinationBook(14); // Call the function with your desired parameter
                  }}
                >
                  Upload
                </button>
              </div>
            </div>
          </div>
        </form>
        {individualDocResponse?.length > 0 ? (
          <>
            <div className="px-3">
              <hr />
            </div>
            {individualDocResponse.map((item, index) => (
              <div
                key={item.doc_ID}
                className="container-fluid mt-4 d-flex justify-content-between align-items-center py-4"
                style={{
                  borderRadius: "7px",
                  marginLeft: "21px",
                  width: "96.5%",
                  backgroundColor: "white",
                  border: "1px solid #6a6a6a",
                }}
              >
                <div className="order-main-list d-flex flex-column align-items-start px-2">
                  <h4 style={{ fontSize: "24px", color: "#6A6A6A" }}>
                    Passport
                  </h4>
                  <h5 style={{ fontSize: "16px", color: "#6A6A6A" }}>
                    {formatDate(item.createdDate)}
                  </h5>
                </div>
                <div className="order-main-list d-flex justify-content-start align-items-start p-3">
                  {item.is_submit === 2 ? (
                    <button
                      onClick={() => deleteDoc(item.doc_ID)}
                      style={{
                        display: "flex",
                        height: "35px",
                        width: "100%",
                        marginLeft: "5px",
                        color: "#FF0004",
                        fontSize: "16px",
                        borderStyle: "none",
                        background: "none",
                        padding: "10px 0 0 0",
                      }}
                    >
                      Delete{" "}
                      <DeleteOutlinedIcon
                        className="icon"
                        style={{ padding: "0 0 0 4px" }}
                      />
                    </button>
                  ) : null}
                  {item.is_submit === 2 ? (
                  <a
                    style={{
                      display: "flex",
                      color: "#00A3FF",
                      textDecoration: "none",
                      cursor: "pointer",
                      fontWeight: "bold",
                      width: "100%",
                      padding: "10px",
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                    href={`${baseImageURL}Images/Documents/${item.relocation_id}/${item.doc_name}`}
                    download={`${item.doc_name}`}
                  >
                    Preview{" "}
                    <FontAwesomeIcon
                      icon={faArrowUpRightFromSquare}
                      style={{ padding: "5px 4px 0px 11px", color: "#00A3FF" }}
                    />
                  </a>
                  ):null}
                  {item.is_submit === 2 ? (
                    <button
                      style={{
                        color: "#28A745",
                        width: "100%",
                        marginTop: "10px",
                        fontWeight: "bold",
                        textDecoration: "none",
                        border: "none",
                        backgroundColor: "white",
                        display: "flex",
                      }}
                      onClick={() => submitDocument(item.doc_ID)}
                    >
                      Submit{" "}
                      <FontAwesomeIcon
                        icon={faArrowRightFromBracket}
                        style={{
                          padding: "5px 4px 0px 11px",
                          color: "#28A745",
                        }}
                      />
                    </button>
                  ) : (
                    <button
                      style={{
                        color: "#28A745",
                        width: "82%",
                        marginTop: "9.5px",
                        fontWeight: "bold",
                        cursor: "default",
                        textDecoration: "none",
                        border: "none",
                        backgroundColor: "white",
                      }}
                      className="btn btn-success inputDoc3"
                    >
                      Submitted
                    </button>
                  )}
                </div>
              </div>
            ))}
          </>
        ) : null}
      </div>
      <div
        className="p-4 mt-4"
        style={{ backgroundColor: "rgb(250, 250, 250)", borderRadius: "8px" }}
      >
        <h4 style={{ fontSize: "20px" }}>2. VISA Verification</h4>
        <h6 className="px-4" style={{ fontSize: "16px", color: "#A0A0A0" }}>
          We need to verify the VISA details of the pet parent to ensure no
          discrepancies occur on the day of travel.{" "}
          <span style={{ color: "#0096EB" }}>More Info</span>
        </h6>
        <form className="relocation-details-main-form mt-0 px-2 execution-step-1-form">
          <div className="form-row mt-0 row align-items-center">
            <div className="col-4" style={{ marginTop: "15px" }}>
              <label
                style={{ color: "#3D3D3D", marginRight: "10px" }}
                htmlFor=""
              >
                Date of VISA submission.
              </label>
              <div className="d-flex align-items-baseline">
                <input
                  id="vaccinationDate"
                  style={{
                    border: "2px solid #6a6a6a",
                    width: "100%",
                    borderTopLeftRadius: "8px",
                    borderBottomLeftRadius: "8px",
                    borderTopRightRadius: "0px",
                    borderBottomRightRadius: "0px",
                  }}
                  type="date"
                  className="form-control m-0"
                  placeholder="Enter"
                  name="dateValue2"
                  value={dateValue2}
                  onChange={handleChange}
                />
                <button
                  style={{
                    border: "2px solid #5B489D",
                    marginLeft: "6px",
                    backgroundColor: "#F8F9FACC",
                    color: "#6a6a6a",
                    with: "114px",
                    padding: "6px 16px 6px 16px",
                    borderTopRightRadius: "8px",
                    borderBottomRightRadius: "8px",
                  }}
                  type="submit"
                  className="form-button execution-update-btn"
                >
                  Update
                </button>
              </div>
            </div>

            <div className="col-4" style={{ marginTop: "15px" }}>
              <label
                style={{ color: "#3D3D3D", marginRight: "10px" }}
                htmlFor=""
              >
                VISA Validity
              </label>
              <div className="d-flex align-items-baseline">
                <input
                  id="vaccinationDate"
                  style={{
                    border: "2px solid #6a6a6a",
                    width: "100%",
                    borderTopLeftRadius: "8px",
                    borderBottomLeftRadius: "8px",
                    borderTopRightRadius: "0px",
                    borderBottomRightRadius: "0px",
                  }}
                  type="date"
                  className="form-control m-0"
                  placeholder="Enter"
                  name="validity"
                  value={firstItem.validity}
                  onChange={handleChangeDoc}
                />
                <button
                  style={{
                    border: "2px solid #5B489D",
                    marginLeft: "6px",
                    backgroundColor: "#F8F9FACC",
                    color: "#6a6a6a",
                    with: "114px",
                    padding: "6px 16px 6px 16px",
                    borderTopRightRadius: "8px",
                    borderBottomRightRadius: "8px",
                  }}
                  type="submit"
                  className="form-button execution-update-btn"
                >
                  Update
                </button>
              </div>
            </div>

            <div className="col-4" style={{ marginTop: "15px" }}>
              <label
                style={{ color: "#3D3D3D", marginRight: "10px" }}
                htmlFor=""
              >
                Upload Document
              </label>
              <div className="d-flex align-items-baseline">
                <input
                  id="vaccinationDate"
                  style={{
                    border: "2px solid #6a6a6a",
                    width: "100%",
                    borderTopLeftRadius: "8px",
                    borderBottomLeftRadius: "8px",
                    borderTopRightRadius: "0px",
                    borderBottomRightRadius: "0px",
                  }}
                  type="file"
                  className="form-control m-0"
                  placeholder="Enter"
                  name="doc_name"
                  onChange={handleChangeDoc}
                  ref={fileInputRef}
                  required
                />
                <button
                  style={{
                    border: "2px solid #5B489D",
                    marginLeft: "6px",
                    backgroundColor: "#F8F9FACC",
                    color: "#6a6a6a",
                    with: "114px",
                    padding: "6px 16px 6px 16px",
                    borderTopRightRadius: "8px",
                    borderBottomRightRadius: "8px",
                  }}
                  className="form-button execution-update-btn"
                  onClick={(e) => {
                    e.preventDefault(); // Explicitly prevent default form submission
                    uploadVaccinationBook(18); // Call the function with your desired parameter
                  }}
                >
                  Upload
                </button>
              </div>
            </div>
          </div>
        </form>

        {individualDocResponse2?.length > 0 ? (
          <>
            <div className="px-3">
              <hr />
            </div>
            {individualDocResponse2.map((item, index) => (
              <div
                key={item.doc_ID}
                className="container-fluid mt-4 d-flex justify-content-between align-items-center py-4"
                style={{
                  borderRadius: "7px",
                  marginLeft: "21px",
                  width: "96.5%",
                  backgroundColor: "white",
                  border: "1px solid #6a6a6a",
                }}
              >
                <div className="order-main-list d-flex flex-column align-items-start px-2">
                  <h4 style={{ fontSize: "24px", color: "#6A6A6A" }}>VISA</h4>
                  <h5 style={{ fontSize: "16px", color: "#6A6A6A" }}>
                    {formatDate(item.createdDate)}
                  </h5>
                </div>
                <div className="order-main-list d-flex justify-content-start align-items-start p-3">
                  {item.is_submit === 2 ? (
                    <button
                      onClick={() => deleteDoc(item.doc_ID)}
                      style={{
                        display: "flex",
                        height: "35px",
                        width: "100%",
                        marginLeft: "5px",
                        color: "#FF0004",
                        fontSize: "16px",
                        borderStyle: "none",
                        background: "none",
                        padding: "10px 0 0 0",
                      }}
                    >
                      Delete{" "}
                      <DeleteOutlinedIcon
                        className="icon"
                        style={{ padding: "0 0 0 4px" }}
                      />
                    </button>
                  ) : null}
                  {item.is_submit === 2 ? (
                  <a
                    style={{
                      display: "flex",
                      color: "#00A3FF",
                      textDecoration: "none",
                      cursor: "pointer",
                      fontWeight: "bold",
                      width: "100%",
                      padding: "10px",
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                    href={`${baseImageURL}Images/Documents/${item.relocation_id}/${item.doc_name}`}
                    download={`${item.doc_name}`}
                  >
                    Preview{" "}
                    <FontAwesomeIcon
                      icon={faArrowUpRightFromSquare}
                      style={{ padding: "5px 4px 0px 11px", color: "#00A3FF" }}
                    />
                  </a>
                  ):null}
                  {item.is_submit === 2 ? (
                    <button
                      style={{
                        color: "#28A745",
                        width: "100%",
                        marginTop: "10px",
                        fontWeight: "bold",
                        textDecoration: "none",
                        border: "none",
                        backgroundColor: "white",
                        display: "flex",
                      }}
                      onClick={() => submitDocument(item.doc_ID)}
                    >
                      Submit{" "}
                      <FontAwesomeIcon
                        icon={faArrowRightFromBracket}
                        style={{
                          padding: "5px 4px 0px 11px",
                          color: "#28A745",
                        }}
                      />
                    </button>
                  ) : (
                    <button
                      style={{
                        color: "#28A745",
                        width: "82%",
                        marginTop: "9.5px",
                        fontWeight: "bold",
                        cursor: "default",
                        textDecoration: "none",
                        border: "none",
                        backgroundColor: "white",
                      }}
                      className="btn btn-success inputDoc3"
                    >
                      Submitted
                    </button>
                  )}
                </div>
              </div>
            ))}
          </>
        ) : null}
      </div>
      <div
        className="p-4 mt-4"
        style={{ backgroundColor: "rgb(250, 250, 250)", borderRadius: "8px" }}
      >
        <h4 style={{ fontSize: "20px" }}>3. Air Ticket Verification</h4>
        <h6 className="px-4" style={{ fontSize: "16px", color: "#A0A0A0" }}>
          We need to verify the Air Ticket details of the pet parent to ensure
          no discrepancies occur on the day of travel.{" "}
          <span style={{ color: "#0096EB" }}>More Info</span>
        </h6>
        <form className="relocation-details-main-form mt-0 px-2 execution-step-1-form">
          <div className="form-row mt-0 row align-items-center">
            <div className="col-4" style={{ marginTop: "15px" }}>
              <label
                style={{ color: "#3D3D3D", marginRight: "10px" }}
                htmlFor=""
              >
                Select Origin
              </label>
              <div className="d-flex align-items-baseline">
                <select
                  id="vaccinationDate"
                  style={{
                    border: "2px solid #6a6a6a",
                    width: "100%",
                    borderTopLeftRadius: "8px",
                    borderBottomLeftRadius: "8px",
                    borderTopRightRadius: "0px",
                    borderBottomRightRadius: "0px",
                  }}
                  type="date"
                  className="form-control m-0"
                  placeholder="Enter"
                ></select>
              </div>
            </div>

            <div className="col-4" style={{ marginTop: "15px" }}>
              <label
                style={{ color: "#3D3D3D", marginRight: "10px" }}
                htmlFor=""
              >
                Select Destination
              </label>
              <div className="d-flex align-items-baseline">
                <select
                  id="vaccinationDate"
                  style={{
                    border: "2px solid #6a6a6a",
                    width: "100%",
                    borderTopLeftRadius: "8px",
                    borderBottomLeftRadius: "8px",
                    borderTopRightRadius: "0px",
                    borderBottomRightRadius: "0px",
                  }}
                  type="date"
                  className="form-control m-0"
                  placeholder="Enter"
                ></select>
              </div>
            </div>

            <div className="col-4" style={{ marginTop: "15px" }}>
              <label
                style={{ color: "#3D3D3D", marginRight: "10px" }}
                htmlFor=""
              >
                Date of Travel
              </label>
              <div className="d-flex align-items-baseline">
                <input
                  id="vaccinationDate"
                  style={{
                    border: "2px solid #6a6a6a",
                    width: "100%",
                    borderTopLeftRadius: "8px",
                    borderBottomLeftRadius: "8px",
                    borderTopRightRadius: "0px",
                    borderBottomRightRadius: "0px",
                  }}
                  type="date"
                  className="form-control m-0"
                  placeholder="Enter"
                  name="validity"
                  value={firstItem.validity}
                  onChange={handleChangeDoc}
                />
                <button
                  style={{
                    border: "2px solid #5B489D",
                    marginLeft: "6px",
                    backgroundColor: "#F8F9FACC",
                    color: "#6a6a6a",
                    with: "114px",
                    padding: "6px 16px 6px 16px",
                    borderTopRightRadius: "8px",
                    borderBottomRightRadius: "8px",
                  }}
                  type="submit"
                  className="form-button execution-update-btn"
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        </form>
        <form className="relocation-details-main-form mt-0 px-2 execution-step-1-form">
          <div className="form-row mt-0 row align-items-center">
            <div className="col-4" style={{ marginTop: "15px" }}>
              <label
                style={{ color: "#3D3D3D", marginRight: "10px" }}
                htmlFor=""
              >
                Date of air ticket submission.
              </label>
              <div className="d-flex align-items-baseline">
                <input
                  id="vaccinationDate"
                  style={{
                    border: "2px solid #6a6a6a",
                    width: "100%",
                    borderTopLeftRadius: "8px",
                    borderBottomLeftRadius: "8px",
                    borderTopRightRadius: "0px",
                    borderBottomRightRadius: "0px",
                  }}
                  type="date"
                  className="form-control m-0"
                  placeholder="Enter"
                  name="dateValue3"
                  value={dateValue3}
                  onChange={handleChangeDoc}
                />
                <button
                  style={{
                    border: "2px solid #5B489D",
                    marginLeft: "6px",
                    backgroundColor: "#F8F9FACC",
                    color: "#6a6a6a",
                    with: "114px",
                    padding: "6px 16px 6px 16px",
                    borderTopRightRadius: "8px",
                    borderBottomRightRadius: "8px",
                  }}
                  type="submit"
                  className="form-button execution-update-btn"
                >
                  Update
                </button>
              </div>
            </div>

            <div className="col-4" style={{ marginTop: "15px" }}>
              <label
                style={{ color: "#3D3D3D", marginRight: "10px" }}
                htmlFor=""
              >
                Upload Document
              </label>
              <div className="d-flex align-items-baseline">
                <input
                  id="vaccinationDate"
                  style={{
                    border: "2px solid #6a6a6a",
                    width: "100%",
                    borderTopLeftRadius: "8px",
                    borderBottomLeftRadius: "8px",
                    borderTopRightRadius: "0px",
                    borderBottomRightRadius: "0px",
                  }}
                  type="file"
                  className="form-control m-0"
                  placeholder="Enter"
                  name="doc_name"
                  onChange={handleChangeDoc}
                  ref={fileInputRef}
                  required
                />
                <button
                  style={{
                    border: "2px solid #5B489D",
                    marginLeft: "6px",
                    backgroundColor: "#F8F9FACC",
                    color: "#6a6a6a",
                    with: "114px",
                    padding: "6px 16px 6px 16px",
                    borderTopRightRadius: "8px",
                    borderBottomRightRadius: "8px",
                  }}
                  className="form-button execution-update-btn"
                  onClick={(e) => {
                    e.preventDefault(); // Explicitly prevent default form submission
                    uploadVaccinationBook(12); // Call the function with your desired parameter
                  }}
                >
                  Upload
                </button>
              </div>
            </div>
          </div>
        </form>
        {individualDocResponse3?.length > 0 ? (
          <>
            <div className="px-3">
              <hr />
            </div>
            {individualDocResponse3.map((item, index) => (
              <div
                key={item.doc_ID}
                className="container-fluid mt-4 d-flex justify-content-between align-items-center py-4"
                style={{
                  borderRadius: "7px",
                  marginLeft: "21px",
                  width: "96.5%",
                  backgroundColor: "white",
                  border: "1px solid #6a6a6a",
                }}
              >
                <div className="order-main-list d-flex flex-column align-items-start px-2">
                  <h4 style={{ fontSize: "24px", color: "#6A6A6A" }}>
                    Air Ticket
                  </h4>
                  <h5 style={{ fontSize: "16px", color: "#6A6A6A" }}>
                    {formatDate(item.createdDate)}
                  </h5>
                </div>
                <div className="order-main-list d-flex justify-content-start align-items-start p-3">
                  {item.is_submit === 2 ? (
                    <button
                      onClick={() => deleteDoc(item.doc_ID)}
                      style={{
                        display: "flex",
                        height: "35px",
                        width: "100%",
                        marginLeft: "5px",
                        color: "#FF0004",
                        fontSize: "16px",
                        borderStyle: "none",
                        background: "none",
                        padding: "10px 0 0 0",
                      }}
                    >
                      Delete{" "}
                      <DeleteOutlinedIcon
                        className="icon"
                        style={{ padding: "0 0 0 4px" }}
                      />
                    </button>
                  ) : null}
                  {item.is_submit === 2 ? (
                  <a
                    style={{
                      display: "flex",
                      color: "#00A3FF",
                      textDecoration: "none",
                      cursor: "pointer",
                      fontWeight: "bold",
                      width: "100%",
                      padding: "10px",
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                    href={`${baseImageURL}Images/Documents/${item.relocation_id}/${item.doc_name}`}
                    download={`${item.doc_name}`}
                  >
                    Preview{" "}
                    <FontAwesomeIcon
                      icon={faArrowUpRightFromSquare}
                      style={{ padding: "5px 4px 0px 11px", color: "#00A3FF" }}
                    />
                  </a>
                  ):null}
                  {item.is_submit === 2 ? (
                    <button
                      style={{
                        color: "#28A745",
                        width: "100%",
                        marginTop: "10px",
                        fontWeight: "bold",
                        textDecoration: "none",
                        border: "none",
                        backgroundColor: "white",
                        display: "flex",
                      }}
                      onClick={() => submitDocument(item.doc_ID)}
                    >
                      Submit{" "}
                      <FontAwesomeIcon
                        icon={faArrowRightFromBracket}
                        style={{
                          padding: "5px 4px 0px 11px",
                          color: "#28A745",
                        }}
                      />
                    </button>
                  ) : (
                    <button
                      style={{
                        color: "#28A745",
                        width: "82%",
                        marginTop: "9.5px",
                        fontWeight: "bold",
                        cursor: "default",
                        textDecoration: "none",
                        border: "none",
                        backgroundColor: "white",
                      }}
                    >
                      Submitted
                    </button>
                  )}
                </div>
              </div>
            ))}
          </>
        ) : null}
      </div>
    </>
  );
}

export default ExecutionAndDocumentationDesktopStep4;
